import { useEffect, useState } from 'react';

import { logReadFailure } from '../lib/net/logReadFailure';
import { rescheduleBaseOf } from '../lib/appointments/rescheduleLink';
import { supabase } from '../lib/supabase';

/**
 * The reschedule page for an appointment card (`src/lib/appointments/rescheduleLink.ts`): read when the
 * card mounts, so a change in Settings › Rendez-vous shows at the next opening. Null while it is read,
 * when none is configured, or when the setting cannot be read (logged): the card then shows no link.
 */
export function useRescheduleBase(): string | null {
  const [base, setBase] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    void supabase.rpc('get_appointments_settings').then(({ data, error }) => {
      if (error) logReadFailure('appointments', 'get_appointments_settings() read failed', error);
      const setting: string | null | undefined = error ? null : data?.[0]?.reschedule_url;
      if (alive) setBase(rescheduleBaseOf(setting, import.meta.env.VITE_RESCHEDULE_BASE_URL));
    });
    return () => {
      alive = false;
    };
  }, []);
  return base;
}
